import { connect } from 'react-redux';

import convertMoneyToCurrency from '../../utils/convertMoneyToCurrency';
import formatMoneyBase from '../../utils/formatMoney';

import { getWebmasterCurrency } from '../../../../webmaster/selectors';
import { getExchangeRatesForEur } from '../../../../init/selectors/exchangeRatesForEur';


export default Component => {
  const mapStateToProps = state => ({
    formatMoney: money => {
      if (!money || (Array.isArray(money) && money.length === 0)) {
        return '0';
      }

      const wmCurrency = getWebmasterCurrency(state);
      const exchangeRate = getExchangeRatesForEur(state);

      let result;
      if (Array.isArray(money)) {
        result = {
          amount: 0,
          currency: wmCurrency,
        };

        money.forEach(m => {
          if (m) {
            const newMoney = convertMoneyToCurrency(m, wmCurrency, exchangeRate);
            result.amount += newMoney.amount;
          }
        });
      } else {
        result = convertMoneyToCurrency(money, wmCurrency, exchangeRate);
      }

      return formatMoneyBase(result);
    },
  });

  return connect(mapStateToProps)(Component);
};
